console.log('including common...');
/////////////////////////////////////////////
///////////// Execute stuff /////////////////
/////////////////////////////////////////////
import $ from 'jquery';
import Dropzone from 'dropzone';
import Popper from 'popper.js'
import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all';
import katex from 'katex';
import bsCustomFileInput from 'bs-custom-file-input'

// set globals
window.$ = $;
// window.jQuery = $;
window.Dropzone   = Dropzone;
window.Popper     = Popper;
window.katex      = katex;


// some setup
$.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }}); // puts csrf token in ajax calls
$(window  ).on('load', function() {
	$("form").each(function (){
		if($(this).attr('method') && $(this).attr('method').toUpperCase() === "POST")
			$(this).prepend(csrf_token_field_html);
	});}); // puts csrf token in any post forms
$(function() { window.reloadTooltipPopover();}); // load bootstrap tooltips and popovers
$(function() {
	// hide any open popovers but targeted one
	$('body').on('click', function (e) {
		$('[data-toggle=popover]').each(function () {
			if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
				$(this).popover('hide');
			}
		});
	});

	// init custom file input
	bsCustomFileInput.init()
});



/////////////////////////////////////////////
//////////////// FUNCTIONS //////////////////
/////////////////////////////////////////////

window.url = function(route){
	if(!route) route = '';
	return cfg_product_root+route;
}
window.backOrClosePopup = function(){
	var opener = window.opener;
	// var opener = window.opener.location
	if(opener) {
		// it's a popup
		window.close();
	}else{
		// it's not a popup
		history.go(-1)
	}
}

window.reloadTooltipPopover = function(){
	console.log('(re)loading tooltips and popovers');
	if($('[data-toggle=tooltip]').length > 0) $("body").tooltip({ selector: '[data-toggle=tooltip]' });
	if($('[data-toggle=popover]').length > 0) $("body").popover({ selector: '[data-toggle=popover]' });
	$('[data-toggle=popover]').on('shown.bs.popover',function(a,b,c){
		$('.mimetex2katex').each(function(k,e){
			katex.render($(e).html().replace(/&amp;/g,"&"), e);
		})
	})
}

window.getHTTPMetaTag = function(metaName) {
	const metas = document.getElementsByTagName('meta');
	for (let i = 0; i < metas.length; i++) {
		if (metas[i].getAttribute('name') === metaName) {
		return metas[i].getAttribute('content');
		}
	}
	return '';
}

window.getAllUrlParams = function(url) {

	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  
	// we'll store the parameters here
	var obj = {};
  
	// if query string exists
	if (queryString) {
  
	  // stuff after # is not part of query string, so get rid of it
	  queryString = queryString.split('#')[0];
  
	  // split our query string into its component parts
	  var arr = queryString.split('&');
  
	  for (var i = 0; i < arr.length; i++) {
		// separate the keys and the values
		var a = arr[i].split('=');
  
		// set parameter name and value (use 'true' if empty)
		var paramName = a[0];
		var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
  
		// (optional) keep case consistent
		paramName = paramName.toLowerCase();
		if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();
  
		// if the paramName ends with square brackets, e.g. colors[] or colors[2]
		if (paramName.match(/\[(\d+)?\]$/)) {
  
		  // create key if it doesn't exist
		  var key = paramName.replace(/\[(\d+)?\]/, '');
		  if (!obj[key]) obj[key] = [];
  
		  // if it's an indexed array e.g. colors[2]
		  if (paramName.match(/\[\d+\]$/)) {
			// get the index value and add the entry at the appropriate position
			var index = /\[(\d+)\]/.exec(paramName)[1];
			obj[key][index] = paramValue;
		  } else {
			// otherwise add the value to the end of the array
			obj[key].push(paramValue);
		  }
		} else {
		  // we're dealing with a string
		  if (!obj[paramName]) {
			// if it doesn't exist, create property
			obj[paramName] = paramValue;
		  } else if (obj[paramName] && typeof obj[paramName] === 'string'){
			// if property does exist and it's a string, convert it to an array
			obj[paramName] = [obj[paramName]];
			obj[paramName].push(paramValue);
		  } else {
			// otherwise add the property
			obj[paramName].push(paramValue);
		  }
		}
	  }
	}
	return obj;
}
window.post = function(url, fields, options){
	if(typeof options === 'object' && options.target == '_popup'){
		var popup = window.open('','');
		var form = $('<form></form>',popup.document);
	} else {
		var form = $('<form></form>');
	}
	form.hide();
	form.attr("action",url);
	form.attr("method","POST");
	if(typeof options === 'object' && options.target == '_blank') form.attr("target","_blank");
	form.append(csrf_token_field_html);

	$.each(fields,function(k,v){
		var tag = "input";
		if(/\r|\n/.exec(v)) tag = "textarea";

		if(typeof v === 'array' || typeof v === 'object'){
			$.each(v,function(z){
				var field = $('<'+tag+'></'+tag+'>');
				field.attr("name",k);
				field.val(z);
				form.append(field);
			});
		} else {
			var field = $('<'+tag+'></'+tag+'>');
			field.attr("name",k);
			field.val(v);
			form.append(field);
		}
	})

	form.appendTo('body').trigger("submit");
}

window.loadPopupModal = function(url){
	url = url.replace("?", "&");
	var popup_url = cfg_product_root+'popupasync?pupup_async_modal_url='+current_route_dir+'/'+url;
	console.log(popup_url);
	$.ajax({
			url: popup_url,
			type: 'GET',
			error: function() {
				console.log('failed to load async');
			},
			success: function(data) {
				appendPopupModalElement(data)
			}
		});
}

window.showPopupModal = function(){
	$('#PopupModal').modal({
		backdrop: false,
		show: true
	});
}
window.hidePopupModal = function(){
	$('#PopupModal').modal({
		backdrop: false,
		show: false
	});
}
window.appendPopupModalElement = function(data){
	// console.log(data);
	// var dom_nodes = $($.parseHTML(data));
	// var new_element_html = dom_nodes.find('#PopupModal').html()
	// console.log(new_element_html);
	$('#app').append($(data));


	window.showPopupModal();
}


window.lockbutonwaitButtonAnimation = function(elem) {
	elem.style.width = elem.offsetWidth;
	var i = 0;
	var id = setInterval(frame, 60);
	wait_interval_id = id;
	var text_loop = "           •••           ".split('');

	function frame() {
		if (Elbtn_wait_anim_stop) return;
		if (i == (text_loop.length - 1)) i = 0;
		else i++;
		text_loop.move(-1,0);
		elem.value = text_loop.join("").substring(0,text_loop.length / 3 * 2 );
	}
}

window.sendRequest = function(method,uri,options,element_spinner){
	if (!options) options = {};
	if (!uri.match(/^http/i)) uri = cfg_product_root+uri.replace(/^\/*/,'');
	var spinner_element = $(element_spinner)
	if(spinner_element.next('.invalid-feedback'))spinner_element.next('.invalid-feedback').remove()

	var previous_html = spinner_element.html();
	spinner_element.prop('disabled',true);
	spinner_element.html($(`
		<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
		<span>Loading...</span>
	`))
	var end_spinner = function(){
		spinner_element.html(previous_html);
		spinner_element.prop('disabled',false);
	}

	// if(is a input/button) 

	try{
		var resp = false;
		$.ajax({
			async : false,
			url : uri,
			data: options,
			cache: true,
			type: method,
			dataType : "json",
			// beforeSend : function(){return;},
			success : function(data){
				resp = data;
				end_spinner()
				console.log('response success:',data)
				return true;
			},
			error: function(e){
				var invalid_div = $(`<div class="invalid-feedback"></div>`)

				// if(e.status != 200)
				var error_message = '';
				if(e.responseJSON && e.responseJSON['messages']) error_message = e.responseJSON['messages'].join('<br>');
				else {
					error_message = 'Error '+e.status+': '+e.statusText
				}

				
				invalid_div.html(error_message)
				
				spinner_element.after(invalid_div);
				spinner_element.addClass('is-invalid');
				
				console.log(invalid_div)
				
				console.log(e.status);
				console.log(e.statusText);
				console.log(e.responseText)
				console.log(e);
				end_spinner()
				return false;
			}
		});
		return resp;
	}catch(err){
		end_spinner()
		console.log('ajax error caught',err)
		return false;
	}
}

window.requestLegacyPopup = function(url,method){
	if(method === undefined) method = 'GET';
	$.ajax({
		url: url,
		type: method,
		beforeSend: function(jqXHR, settings) {
			jqXHR.url = url;
		},
		error: function() {
			console.log('failed to load async');
		},
		success: window.handleLegacyPopupModalResponse
	});
}
window.wasLegacyPopupClosed = function(htmlData){
	return /^\s*<script/.test(htmlData) // if the page starts with a scrip, it usually means a PHP function such as JavaScriptBootstrapTableRefreshOpenerAndClose() was used
		|| /^\s*$/.test(htmlData) // if nothing is displayed, we assume this is closed
}
window.legacyPopupModalFindAll = function(htmlData){
	return $('div[id^="modal-"].modal.fade');
}
window.legacyPopupModalDispose = function(htmlData){
	window.legacyPopupModalFindAll().modal('hide');
}

window.handleLegacyPopupModalResponse = function(responseData,status,xhr){
	if(window.wasLegacyPopupClosed(responseData)) {
		// success, refresh table and close hide the modal
		window.$bootstrapTable.bootstrapTable('refresh');
		window.legacyPopupModalDispose();
		return;
	} else {
		// remove existing modals anyway, we will popup another one
		window.legacyPopupModalDispose()
	}


	// make a modal with the form displayed in the responseData
	var responseHtml = $(responseData);
	var mainBodyElement = responseHtml.find('#mainbody,.mainbody').first();
	if (mainBodyElement.length == 0) mainBodyElement = $('<div>'+responseData+'</div>').find('#mainbody,.mainbody').first(); // seems like sometimes it doesn't get it is a dom, so we wrap it inside a <div>
	if (mainBodyElement.length == 0) mainBodyElement = responseHtml.find('main.py-2');
	if (mainBodyElement.length == 0) mainBodyElement = responseHtml.find('body');
	if (mainBodyElement.length == 0) mainBodyElement = $('<div><p>'+responseData+'</p></div>');
	var responseElement = $('<div></div>')
	responseElement.append(mainBodyElement.html());

	var title_element = responseElement.find('h1').first();

	// if response not html, add a title and a close button
	if(title_element.length == 0) title_element = $('<h1>Message</h1>');
	if(responseElement.find('input').length == 0) responseElement.append($('<button onclick="window.legacyPopupModalDispose()">Close</button>'))

	var title = title_element.text();
	title_element.remove();
	var modal = window.modalCreate();
	window.modalPopulate(modal,()=>({ 'title':title, 'contents':responseElement }));

	// execute scripts we got from the response WARNING: this may produce bugs and unexpected results
	responseHtml.filter('script').each(function(){
		$.globalEval(this.text || this.textContent || this.innerHTML || '');
	});


	// careful to dispose of the modal, cause there is a little bug with serializeArray() stacking submits if we don't
	modal.on('hidden.bs.modal', function(){
		$(this).modal('dispose').remove();
	});

	// cosmetics with css bootstrap
	modal.find('.modal-footer').remove();
	var buttons = modal.find('input[type="submit"]:not(.btn),input[type="button"]:not(.btn),button:not(.btn)')
	buttons.addClass('btn btn-sm');
	buttons.not('input[type="button"],button').addClass('btn-primary');
	buttons.not('input[type="submit"]').addClass('btn-secondary');
	modal.find(`
		input[type="text"]:not(.form-control),
		input[type="password"]:not(.form-control),
		textarea:not(.form-control),
		select:not(.form-control)
	`).addClass('form-control form-control-sm')

	// TODO: handle js functions instead of raw form send
	// prepare the event on form use
	modal.find('form').each(function(k,e){
		var form = $(e);
		e.submit = function(z){
			form.trigger('submit');
		}
		form.on('submit',function(fe){
			// if already prevented by a onsubmit function, abort
			if(fe.originalEvent !== undefined && fe.originalEvent.defaultPrevented) return false;

			// prevent default behaviour if still going
			fe.preventDefault();

			// get original form data
			var form_element = form;
			var method = form_element.attr("method");
			var data = form_element.serializeArray();
			$('input[type="submit"]').each((k,i)=> data.push({ name: i.name, value: i.value })) // because serialize doesn't include input[type="submit"] ...
			var action = form_element.attr('action') === undefined ? xhr.url  : form_element.attr('action');

			// send the request and handle the response
			$.ajax({
				url: action,
				type: method,
				data: data,
				beforeSend: function(jqXHR, settings) {
					jqXHR.url = action;
				},
				error: function() {
					console.log('failed to load async');
				},
				success: handleLegacyPopupModalResponse // loop through this function if there is a response
			})
		})
	})

	modal.modal({
		backdrop: true,
		show: true
	});

}

window.modalCreate = function(){
	var modal_id = 'modal-'+Math.random().toString(36).slice(2);
	var modal_element = $(`
	<div class="modal fade" id="`+modal_id+`" tabindex="-1" aria-labelledby="`+modal_id+`-label" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
			<div class="modal-header">
				<h2 class="modal-title" id="`+modal_id+`-label">Modal title</h2>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div id="`+modal_id+`-contents" class="modal-body"></div>
			<div id="`+modal_id+`-footer" class="modal-footer">
				<div id="`+modal_id+`-controls" class="flex-fill">
				</div>
				<button type="button" class="btn btn-sm btn-light align-self-end" data-dismiss="modal">Close</button>
			</div>
			</div>
		</div>
	</div>
	`);
	$("div#mainbody:first").append(modal_element);

	return modal_element;
}
window.modalPopulate = function(modal_element,callbackInfo){
	var modal_id = modal_element.prop('id');
	var label_id    = modal_id+'-label';
	var contents_id = modal_id+'-contents';
	var controls_id   = modal_id+'-controls';

	var label_element    = modal_element.find('#'+label_id);
	var contents_element = modal_element.find('#'+contents_id);
	var controls_element   = modal_element.find('#'+controls_id);

	
	var info = callbackInfo()

	label_element.text(info.title);
	contents_element.append(info.contents);
	controls_element.prepend(info.controls);

	return modal_element;
}
window.modalPopulateRequest = function(modal_element,uri,method,options){
	if(!options) options = {};
	if(!method) method = 'GET';
	return modalPopulate(modal_element,function(){
		var response = sendRequest(method,uri,options,null);

		return {
			'title':response.title,
			'contents':response.contents,
			'controls':response.controls,
		}
	})
}
window.modalPopulateJs = function(modal_element,title,contents,controls){
	return modalPopulate(modal_element,function(){

		return {
			'title':title,
			'contents':contents,
			'controls':controls,
		}
	})
}

window.toggleBootstrapBtn = function(){
	return toggleBootstrap('bootstrap_btn_only.css')
}
window.toggleBootstrapPlacement = function(){
	return toggleBootstrap('bootstrap_placement_only.css')
}
window.toggleBootstrapCommonTags = function(){
	return toggleBootstrap('bootstrap_common_tags.css')
}
window.toggleBootstrap = function(css_file){
	if ($('link[rel=stylesheet][href$="'+css_file+'"]').length > 0){
		$('link[rel=stylesheet][href$="'+css_file+'"]').remove()
	} else {
		$('head').append('<link rel="stylesheet" type="text/css" href="'+asset('css/')+css_file+'">');
	}
}
window.asset = function(path){
	return cfg_common_web_root + 'resources/assets/' + path.replace(/^\//, '');
}


window.RefreshOpenersDataTable = function(e){
	if(window.opener){
		console.log('windows opener detected, refresh opener and close self')
		if(window.opener.$bootstrapTable) window.opener.$bootstrapTable.bootstrapTable('refresh');
		else if( $('iframe',window.opener.document).length > 0) $('iframe',window.opener.document).attr( 'src', function ( i, val ) { return val; });
		else window.opener.location.reload(false);
	} else {
		if(window.$bootstrapTable) window.$bootstrapTable.bootstrapTable('refresh');
	}
}
window.RefreshOpenersDataTableAndClose = function(e){
	window.RefreshOpenersDataTable(e);
	if(window.opener) window.close();
	else if(legacyPopupModalFindAll().length > 0 ){ // is modal
		legacyPopupModalDispose();
	}
}